import axios from "axios";
import store from "../store";
import { jwtDecode } from "jwt-decode";
import {
  getActiveDatabase,
  getDatabase,
  setActiveDatabase,
  clearActiveDatabase,
  isLiveCasinoActive,
  isDatabaseActive,
  toggleLiveCasinoFilter,
  getActiveCategory,
  getComputedDatabase,
  DB_STORAGE_KEY,
  DEFAULT_DATABASE,
  DB_MAPPING,
} from "../helpers/databaseMapping";

let decodedSkins = [];

const encryptedSkins = localStorage.getItem("skins");
if (encryptedSkins) {
  try {
    const decodedString = atob(encryptedSkins);
    try {
      decodedSkins = JSON.parse(decodedString);
    } catch (jsonError) {
      if (decodedString.includes(",")) {
        decodedSkins = decodedString
          .split(",")
          .map((item) => Number(item.trim()));
      } else {
        decodedSkins = [Number(decodedString)];
      }
    }
    // Assicuriamoci di avere un array e rimuoviamo eventuali NaN
    if (!Array.isArray(decodedSkins)) {
      decodedSkins = [decodedSkins];
    }
    decodedSkins = decodedSkins.filter((item) => !isNaN(item));
  } catch (error) {
    console.error("Error durante la decodifica di skins:", error);
  }
}

const axiosClient = axios.create({
  baseURL: "/", // URL del tuo server Node.js
  headers: {
    "Content-Type": "application/json",
  },
});

// Helper to construct normalized API URL with DB and category
const formatApiUrl = (baseUrl, db, endpoint) => {
  const base = baseUrl || "";
  const cleanBase = base.endsWith("/") ? base : `${base}/`;
  const cleanEndpoint = (endpoint || "").startsWith("/")
    ? (endpoint || "").slice(1)
    : endpoint || "";
  let url = `${cleanBase}${db}/${cleanEndpoint}`;
  return url.replace(/([^:]\/)\/+/g, "$1");
};

// Qui aggiungi l’interceptor per il token
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("botokentheear");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("botokentheear");

      location.reload();
    }

    return Promise.reject(error);
  }
);

export const get = async (endpoint, params = {}) => {
  try {
    let url = process.env.VUE_APP_APIENDPOINT + endpoint;

    const response = await axiosClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta GET:", error.message);
    throw error;
  }
};


export const getFetchMS = async (endpoint, params = {}) => {
  try {
    let url = endpoint
    const response = await axiosClient.get(url, { params })
    return response.data
  } catch (error) {
    console.error('Error:', error.message)
    throw error
  }
}

export const getFetch = async (
  endpoint,
  params = {},
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);

    let skinToFilt = store.state.skinStorage ?? false;
    if (shouldFilter && skinToFilt) {
      params = { ...params, skin_id: skinToFilt };
    }

    const response = await axiosClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta GET:", error.message);
    throw error;
  }
};

export const postFetch = async (
  endpoint,
  params = {},
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);

    let skinToFilt = store.state.skinStorage ?? false;

    if (shouldFilter && skinToFilt) {
      params = { ...params, skin_id: skinToFilt };
    }
    const response = await axiosClient.post(url, params);
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta POST:", error.message);
    throw error;
  }
};

export const postFormDataFile = async (
  endpoint,
  formData,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axiosClient.post(url, formData, config);

    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta POST:", error.message);
    throw error;
  }
};

export const putFetch = async (
  endpoint,
  params = {},
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);
    const response = await axiosClient.put(url, params);
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta PUT:", error.message);
    throw error;
  }
};

export const deleteRequest = async (
  endpoint,
  params = {},
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);
    const response = await axiosClient.delete(url, { data: params });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta DELETE:", error.message);
    throw error;
  }
};

export const getDownloadCsv = async (
  endpoint,
  params = {},
  freebet_id,
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(
      baseUrl,
      db,
      `${endpoint}/downloadCsv/${freebet_id}`
    );

    let skinToFilt = store.state.skinStorage ?? false;

    if (shouldFilter && skinToFilt) {
      params = { ...params, skin_id: skinToFilt };
    }

    const response = await axiosClient.get(url, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta GET:", error.message);
    throw error;
  }
};

export const getDownloadCsv2 = async (
  endpoint,
  exportFile = {},
  freebet_id = "",
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    const skinQuery = store.state.skinStorage
      ? "?skin_id=" + store.state.skinStorage
      : "";
    let url = formatApiUrl(
      baseUrl,
      db,
      `${endpoint}/csv/${freebet_id}${skinQuery}`
    );

    let skinToFilt = store.state.skinStorage ?? false;

    if (shouldFilter && skinToFilt) {
      exportFile = { ...exportFile, skin_id: skinToFilt };
    }

    const response = await axiosClient.post(url, exportFile, {
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta POST:", error.message);
    throw error;
  }
};

export const getDownloadPdf = async (
  endpoint,
  params = {},
  freebet_id,
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, `${endpoint}/downloadPdf${freebet_id}`);

    let skinToFilt = store.state.skinStorage ?? false;

    if (shouldFilter && skinToFilt) {
      params = { ...params, skin_id: skinToFilt };
    }

    const response = await axiosClient.get(url, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta GET per il PDF:", error.message);
    throw error;
  }
};

export const postForm = async (
  endpoint,
  params = {},
  shouldFilter = true,
  theearcasinoDB = false
) => {
  try {
    const db = getComputedDatabase(theearcasinoDB);
    const baseUrl = process.env.VUE_APP_APIENDPOINT;
    let url = formatApiUrl(baseUrl, db, endpoint);

    let skinToFilt = store.state.skinStorage ?? false;

    if (shouldFilter && skinToFilt) {
      params = { ...params, skin_id: skinToFilt };
    }

    const response = await axiosClient.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Errore durante la richiesta POST form:", error.message);
    throw error;
  }
};
export default axiosClient;

export const buildSkinFilter = (decodedSkins) => {
  const skinIds = Array.isArray(decodedSkins) ? decodedSkins : [];

  if (skinIds.length > 0) {
    return { skin_auth: skinIds };
  }

  return {};
};

export {
  getActiveDatabase,
  getDatabase,
  setActiveDatabase,
  clearActiveDatabase,
  isLiveCasinoActive,
  isDatabaseActive,
  toggleLiveCasinoFilter,
  getActiveCategory,
  getComputedDatabase,
  DB_STORAGE_KEY,
  DEFAULT_DATABASE,
  DB_MAPPING,
};
